import React from 'react';
import { Image } from 'react-native';

export const TimelineIcon = (props) => {
    return (
        <Image
            source={resolveIcon(props.contentType)}
            style={{ height: 32, width: 32, margin: 4 }}
            resizeMode={'contain'}
        />
    )
}



export const resolveIcon = (contentType) => {
    switch (contentType.toLowerCase().trim()) {

        case "article":
            return require('./icons/article.png');

        case "attendance":
            return require('./icons/attendance.png')

        case "externallink":
            return require('./icons/external-link.png');

        case "quiz":
            return require('./icons/quiz.png');

        case "enigma":
            return require('./icons/quiz.png');

        case "video":
            return require('./icons/videos.png');

        case "webinar":
            return require('./icons/webinar.png');

        case "podcast":
            return require('./icons/podcast.png');

        default:
            return null;
    }
}


